/*
 * This file is part of glowingblue/gamilytics.
 *
 * Copyright (c) 2023 Glowing Blue AG.
 * Authors: Rafael Horvat.
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */

import app from 'flarum/forum/app';
import { slug } from '../../../common';
import Component from 'flarum/common/Component';
import categorizeUserAchievements from '../utils/categorizeUserAchievements';
import UserAchievementsCategory from './UserAchievementsCategory';
const t = function () {
  return app.translator.trans(...arguments);
};
const prfx = `${slug}.forum.user`;
export default class UserAchievementList extends Component {
  oninit(vnode) {
    super.oninit(vnode);
  }
  view() {
    const categories = categorizeUserAchievements(this.attrs.user);
    return m("div", {
      className: "UserAchievements"
    }, categories.length === 0 && m("div", {
      className: "Placeholder"
    }, m("p", null, t(`${prfx}.no_achievements`))), categories.length >= 1 && categories.map(_ref => {
      let {
        category,
        userAchievements
      } = _ref;
      return m(UserAchievementsCategory, {
        category: category,
        userAchievements: userAchievements,
        user: this.attrs.user
      });
    }));
  }
}
flarum.reg.add('glowingblue-gamilytics', 'forum/achievements/components/UserAchievementList', UserAchievementList);